import { useMemo } from 'react';
import { useContext } from '../context';
import { useAccount } from './useAccount';

export const useChains = () => {
  const { config } = useContext();
  const { connector } = useAccount();

  const chains = useMemo(() => {
    const walletConnectorType = connector?.walletConnectorType;
    if (walletConnectorType) {
      const walletConnector = config.getWalletConnector(walletConnectorType);
      if (walletConnector) {
        return walletConnector.chains;
      }
    }
    return config.chains;
  }, [connector, config]);

  return chains;
};
